import {
  Snackbar,
  IconButton,
  SvgIconPropsColorOverrides,
} from "@mui/material";
import { useState } from "react";
import { CopyToClipboardIcon } from "src/assets";
import { OverridableStringUnion } from "@mui/types";

interface CopyToClipboardButtonProps {
  id: string;
  message: string;
  color?:
    | OverridableStringUnion<
        | "disabled"
        | "action"
        | "inherit"
        | "primary"
        | "secondary"
        | "error"
        | "info"
        | "success"
        | "warning",
        SvgIconPropsColorOverrides
      >
    | undefined;
}

const CopyToClipboard = ({
  id,
  color,
  message,
}: CopyToClipboardButtonProps) => {
  const [open, setOpen] = useState(false);
  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    setOpen(true);
    e.stopPropagation();
    navigator.clipboard.writeText(id);
  };

  return (
    <>
      <IconButton aria-label="content-copy" onClick={handleClick} size="small">
        <CopyToClipboardIcon />
      </IconButton>
      <Snackbar
        open={open}
        message={message}
        autoHideDuration={2000}
        onClose={() => setOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        ContentProps={{
          sx: {
            display: "block",
            textAlign: "center",
          },
        }}
      />
    </>
  );
};

export default CopyToClipboard;
